if (!customElements.get("product-form")) {
	customElements.define(
		"product-form",
		class ProductForm extends HTMLElement {
			constructor() {
				super();

				this.form = this.querySelector("form");
				this.form.querySelector("[name=id]").disabled = false;
				this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
				this.cart =
					document.querySelector("cart-notification") ||
					document.querySelector("cart-drawer");
				this.submitButton = this.querySelector('[type="submit"]');
				if (document.querySelector("cart-drawer"))
					this.submitButton.setAttribute("aria-haspopup", "dialog");

				this.hideErrors = this.dataset.hideErrors === "true";
			}

			onSubmitHandler(evt) {
				evt.preventDefault();
				if (this.submitButton.getAttribute("aria-disabled") === "true") return;

				this.handleErrorMessage();

				this.submitButton.setAttribute("aria-disabled", true);
				this.submitButton.classList.add("loading");
				//this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

				const config = fetchConfig("javascript");
				config.headers["X-Requested-With"] = "XMLHttpRequest";
				delete config.headers["Content-Type"];

				const formData = new FormData(this.form);
				
				// Only include embroidery properties if checkbox is checked and has value
				const embroideryCheckbox = this.form.querySelector('input[data-embroidery-toggle]');
				const embroideryInput = this.form.querySelector('input[name="properties[Embroidery Text]"]');
				const embroideryPosition = this.form.querySelector('select[name="properties[Embroidery Position]"]');
				
				if (embroideryInput) {
					if (!embroideryCheckbox || !embroideryCheckbox.checked || !embroideryInput.value.trim()) {
						// Remove the properties from form if checkbox not checked or no text
						formData.delete('properties[Embroidery Text]');
						if (embroideryPosition) {
							formData.delete('properties[Embroidery Position]');
						}
					}
				}
				
				if (this.cart) {
					formData.append(
						"sections",
						this.cart.getSectionsToRender().map((section) => section.id)
					);
					formData.append("sections_url", window.location.pathname);
					this.cart.setActiveElement(document.activeElement);
				}
				config.body = formData;

				fetch(`${routes.cart_add_url}`, config)
					.then((response) => response.json())
					.then((response) => {
						if (response.status) {
							publish(PUB_SUB_EVENTS.cartError, {
								source: "product-form",
								productVariantId: formData.get("id"),
								errors: response.description,
								message: response.message,
							});
							this.handleErrorMessage(response.description);

							const soldOutMessage =
								this.submitButton.querySelector(".sold-out-message");
							if (!soldOutMessage) return;
							this.submitButton.setAttribute("aria-disabled", true);
							this.submitButton.querySelector("span").classList.add("hidden");
							soldOutMessage.classList.remove("hidden");
							this.error = true;
							return;
						} else if (!this.cart) {
							window.location = window.routes.cart_url;
							return;
						}
						
						// Add embroidery details to cart note and order attributes (without price)
						if (embroideryCheckbox && embroideryCheckbox.checked && embroideryInput && embroideryInput.value.trim()) {
							const embroideryText = embroideryInput.value.trim();
							const embroideryPositionValue = embroideryPosition ? embroideryPosition.value : 'Center';
							const embroideryNote = `Embroidery: ${embroideryText}\nPosition: ${embroideryPositionValue}`;
							
							// Update cart note and attributes immediately - get current cart first
							fetch(`${routes.cart_url}.js`)
								.then(response => response.json())
								.then(cart => {
									let currentNote = cart.note || '';
									let currentAttributes = cart.attributes || {};
									
									// Check if this embroidery text already exists to avoid duplicates
									const noteNeedsUpdate = !currentNote.includes(`Embroidery: ${embroideryText}`);
									
									// Prepare update payload
									const updatePayload = {};
									
									// Update note if needed
									if (noteNeedsUpdate) {
										updatePayload.note = currentNote 
											? `${currentNote}\n${embroideryNote}` 
											: embroideryNote;
									}
									
									// Update attributes (merge with existing attributes)
									updatePayload.attributes = {
										...currentAttributes,
										'Embroidery Text': embroideryText,
										'Embroidery Position': embroideryPositionValue
									};
									
									// Update cart note and attributes
									return fetch(`${routes.cart_update_url}`, {
										...fetchConfig(),
										...{ 
											body: JSON.stringify(updatePayload)
										}
									}).then(updateResponse => {
										// Verify the update was successful
										return fetch(`${routes.cart_url}.js`).then(r => r.json());
									});
								})
								.catch(e => {
									console.error('Failed to update cart note/attributes:', e);
									// Retry once after a short delay
									setTimeout(() => {
										fetch(`${routes.cart_url}.js`)
											.then(response => response.json())
											.then(cart => {
												let currentNote = cart.note || '';
												let currentAttributes = cart.attributes || {};
												
												if (!currentNote.includes(`Embroidery: ${embroideryText}`)) {
													const updatePayload = {
														note: currentNote 
															? `${currentNote}\n${embroideryNote}` 
															: embroideryNote,
														attributes: {
															...currentAttributes,
															'Embroidery Text': embroideryText,
															'Embroidery Position': embroideryPositionValue
														}
													};
													
													fetch(`${routes.cart_update_url}`, {
														...fetchConfig(),
														...{ 
															body: JSON.stringify(updatePayload)
														}
													}).catch(err => console.error('Retry failed:', err));
												} else {
													// Note exists but attributes might not, update attributes only
													const updatePayload = {
														attributes: {
															...currentAttributes,
															'Embroidery Text': embroideryText,
															'Embroidery Position': embroideryPositionValue
														}
													};
													
													fetch(`${routes.cart_update_url}`, {
														...fetchConfig(),
														...{ 
															body: JSON.stringify(updatePayload)
														}
													}).catch(err => console.error('Retry failed:', err));
												}
											});
									}, 500);
								});
						}
						
						// Return the main product response
						return Promise.resolve(response);
					})
					.then((finalResponse) => {
						if (!this.error) {
							publish(PUB_SUB_EVENTS.cartUpdate, {
								source: "product-form",
								productVariantId: formData.get("id"),
							});
							this.error = false;
							const quickAddModal = this.closest("quick-add-modal");
							if (quickAddModal) {
								document.body.addEventListener(
									"modalClosed",
									() => {
										setTimeout(() => {
											this.cart.renderContents(finalResponse);
										});
									},
									{ once: true }
								);
								quickAddModal.hide(true);
							} else {
								this.cart.renderContents(finalResponse);
							}
						}
					})
					.catch((e) => {
						console.error(e);
					})
					.finally(() => {
						this.submitButton.classList.remove("loading");
						if (this.cart && this.cart.classList.contains("is-empty"))
							this.cart.classList.remove("is-empty");
						if (!this.error) this.submitButton.removeAttribute("aria-disabled");
						//this.querySelector('.loading-overlay__spinner').classList.add('hidden');
					});
			}

			handleErrorMessage(errorMessage = false) {
				if (this.hideErrors) return;

				this.errorMessageWrapper =
					this.errorMessageWrapper ||
					this.querySelector(".product-form__error-message-wrapper");
				if (!this.errorMessageWrapper) return;
				this.errorMessage =
					this.errorMessage ||
					this.errorMessageWrapper.querySelector(
						".product-form__error-message"
					);

				this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

				if (errorMessage) {
					this.errorMessage.textContent = errorMessage;
				}
			}
		}
	);
}
